/*
 * HTML5 GeoLocation
 * Asks user for permission, if given, it stores that data in cookie
 */

// global var to handle map loading

window.map_loaded = false;

window.locationSearchUsingLocation = function locationSearchUsingLocation(data, form) {
    var data_json = JSON.parse(data);

    if (form === 'directions') {
        $('.addressSearch input[name="location_search"]').val(data_json.PostalCode);
    } else if (form === 'location') {
        $('.js_directionsForm input[name="location_search"]').val(data_json.PostalCode);
        $('.js_directionsForm .simpleBtn').trigger('click');
    }
}

window.HTML5GeoLocation = function HTML5GeoLocation(form) {
    // check cookie does not exist before checking location
    if (!$.cookie('HTML5GeoLocation')) {
        // html5 geolocation api set up
        if ('geolocation' in navigator) {
            // check if geolocation is supported/enabled on current browser
            navigator.geolocation.getCurrentPosition(
                function success (position) {
                    // for when getting location is a success
                    getAddress(position.coords.latitude, position.coords.longitude, form);
                },
                function error (error_message) {
                    // for when getting location results in an error
                    console.error('An error has occurred while retrieving location', error_message);
                    $('.js_currentLocationSearch').text('Location detection has been disabled by your browser.');
                }
            )
        } else {
            // geolocation is not supported
            console.log('geolocation not supported on this browser.');
            $('.js_currentLocationSearch').text('Location detection not supported on this browser.');
        }
        // cookie exists
    } else {
        // check if location is correct
        locationSearchUsingLocation($.cookie('HTML5GeoLocation'), form);
    }
}

// helper functions for geolocation
var findMatch = function(results, test) {
    for(var i=0; i < results.length; i++) {
        if (test(results[i])) {
            return results[i];
        }
    }

    return undefined;
};

var findResult = function (results, name) {
    var result = findMatch(results, function (obj) {
        return obj.types[0] == name;
    });

    return result ? result.long_name : null;
};

var findResultShortName = function (results, name) {
    var result = findMatch(results, function (obj) {
        return obj.types[0] == name;
    });

    return result ? result.short_name : null;
};

// reverse address lookup using google maps api
window.getAddress = function getAddress (latitude, longitude, form) {
    // api key, required for reverse lookup
    var GOOGLE_MAP_KEY = $('body').data('maps-api-key');

    $.ajax('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=' + GOOGLE_MAP_KEY)
        .then(function success (response) {
                if (response.results[0]) {
                    var results = response.results[0].address_components;

                    var reverseLookupResult = {
                        Latitude: latitude,
                        Longitude: longitude,
                        PostalCode: findResult(results, 'postal_code'),
                        PostalTown: findResult(results, 'postal_town'),
                        Country: findResultShortName(results, 'country'),
                        Region: findResult(results, 'administrative_area_level_1')
                    };

                    // set cookie once address details found
                    $.cookie('HTML5GeoLocation', JSON.stringify(reverseLookupResult), { expires: 3 });

                    // updated to pass in lookup vs cookie due to users may not having accepted cookies
                    locationSearchUsingLocation(JSON.stringify(reverseLookupResult), form);
                }
            },
            function fail (status) {
                console.log('Request failed.  Returned status of', status);
            }
        );
}

window.LocationFormPopulation = function LocationFormPopulation() {
    if ($.cookie('HTML5GeoLocation')) {
        var cookie_data_json = JSON.parse($.cookie('HTML5GeoLocation'));

        if ($('.locationSearchWrap input[name="location_search"]').length) {
            $('.locationSearchWrap input[name="location_search"]').val(cookie_data_json.PostalCode);

            if (map_loaded !== true) {
                loadGoogleMapsOnDemand();
            }
        }
    }
}

$(document).ready(function () {
    'use strict';

    LocationFormPopulation();

    $('.js_currentLocationSearch').on('click', function (e) {
        e.preventDefault();
        var form = $(this).data('form');

        if (map_loaded !== true) {
            loadGoogleMapsOnDemand();
        }

        HTML5GeoLocation(form);
    });

});